import React, { useEffect } from "react";
import "../../../../../Assets/Styles/UserGuide.scss";

const JPAItemsGuide = (props) => {
  useEffect(() => {
    document.getElementById("content-wrapper").style.zIndex = 99999;
    document.getElementById("content-wrapper").style.background = "#F0F2F5";

    // Adding the "none" pointer events to the main wrapper element to
    // disable actions on the JPA items
    document.getElementById("top-jobs").style.pointerEvents = "none";
    document.getElementById("top-projects").style.pointerEvents = "none";
    document.getElementById("top-activities").style.pointerEvents = "none";

    document.getElementById("jpa-items-guide").scrollIntoView();

    return () => {
      document.getElementById("content-wrapper").style.zIndex = 0;
      document.getElementById("content-wrapper").style.background = "unset";

      // Removing the "none" pointer events from the main wrapper element to
      // enable actions on the JPA items
      document.getElementById("top-jobs").style.pointerEvents = "unset";
      document.getElementById("top-projects").style.pointerEvents = "unset";
      document.getElementById("top-activities").style.pointerEvents = "unset";
    };
  }, []);
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  const toggleNextGuide = () => {
    props.ToggleNextDialog();
  };

  const togglePreviousGuide = () => {
    props.TogglePreviousDialog();
  };

  return (
    <div className="guide-dialog jpa-items-guide" id="jpa-items-guide">
      <i className="feather-x" onClick={() => props.CloseGuide()}></i>
      <p className="dialog-text">
        {translateText("walkthrough_homepage_jpa_items")}
      </p>
      <section className="dialog-footer">
        <div className="steps-navs back" onClick={() => togglePreviousGuide()}>
          <i className="feather-arrow-left"></i>
          <p>{translateText("back")}</p>
        </div>
        <div className="indicators">
          <>
            {props.GuideHasAdditionalStep ? (
              <>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((Item, i) => (
                  <span
                    onClick={() => props.JumpToStep(i)}
                    className={
                      i === 2 ? "step-circle active-circle" : "step-circle"
                    }
                    id={"circle-" + parseInt(i)}
                  ></span>
                ))}
              </>
            ) : (
              <>
                {[1, 2, 3, 4, 5, 6, 7, 8].map((Item, i) => (
                  <span
                    onClick={() => props.JumpToStep(Item)}
                    className={
                      i === 1 ? "step-circle active-circle" : "step-circle"
                    }
                    id={"circle-" + parseInt(i + 1)}
                  ></span>
                ))}
              </>
            )}
          </>
        </div>
        <div className="steps-navs next" onClick={() => toggleNextGuide()}>
          <p>{translateText("next")}</p>
          <i className="feather-arrow-right"></i>
        </div>
      </section>
    </div>
  );
};

export default JPAItemsGuide;
